import React from 'react';

import { StickyHeaderLinksBlockData } from 'api/cms';
import Box from 'components/Box';
import { CallToActionButton, PrimaryButtonRouterLink } from 'components/Button';
import { BodySmall, H4, HeadingSmall } from 'components/Text';
import { colors, gutterWidth } from 'theme';
import { isEmpty } from 'utils/functional';

type Data = StickyHeaderLinksBlockData & {
  isGrad?: boolean;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LinksBlock = ({
  data: { links, buttonText, buttonUrl, isGrad },
  loggedIn,
  hasGradProgram,
}: {
  data: Data;
  loggedIn: boolean;
  hasGradProgram: boolean;
}) => {
  const hasButton = !isEmpty(buttonUrl) && !isEmpty(buttonText);
  return (
    <Box
      p={gutterWidth / 2}
      mx={[-gutterWidth / 2, null, -gutterWidth]}
      justifyContent="center"
      borderRadius={[0, 0, 0, 10]}
      bg={colors.fog}
      textAlign="center"
    >
      <HeadingSmall>On this page</HeadingSmall>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        my={-gutterWidth / 2}
      >
        {links.map((link) => (
          <Box
            minWidth={160}
            maxWidth={240}
            width={1 / links.length}
            px={gutterWidth / 2}
            my={gutterWidth / 2}
            key={link.url}
          >
            <Box
              component="a"
              href={`#content-anchor-${link.url}`}
              textDecoration="none"
            >
              <H4 mb="0.375em" lineHeight={1.375}>
                {link.heading}
              </H4>
              {link.subHeading && (
                <BodySmall lineHeight={1.375}>{link.subHeading}</BodySmall>
              )}
            </Box>
          </Box>
        ))}
      </Box>
      {hasButton ? (
        <Box
          mt={gutterWidth / 2}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <PrimaryButtonRouterLink to={buttonUrl}>
            {buttonText}
          </PrimaryButtonRouterLink>
        </Box>
      ) : (
        isGrad && (
          <Box
            mt={gutterWidth / 2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CallToActionButton
              loggedIn={loggedIn}
              hasGradProgram={hasGradProgram}
            />
          </Box>
        )
      )}
    </Box>
  );
};

export default LinksBlock;
